import { Badge, Box, Button, IconButton, Stack, Divider } from "@mui/material";
import { dataTableResponsiveWidth } from "../utils";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";
import { ReactElement } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import BarcodeReaderIcon from "@mui/icons-material/BarcodeReader";

const ControlsIconButton = ({
  icon,
  onClick,
  count = null,
}: {
  icon: ReactElement;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  count?: number | "ghost" | null;
}) => {
  const size = "32px";

  return (
    <Button
      size="small"
      onClick={onClick}
      sx={{
        p: 0,
        display: "flex",
        justifyContent: "center",
        borderRadius: "150px",
        width: size,
        height: size,
        minWidth: size,
      }}
      className="asset-table-icon-button"
      variant="contained"
    >
      <Badge
        invisible={count === null}
        badgeContent={count !== "ghost" ? count : ""}
        color="error"
      >        
        {icon}
      </Badge>
    </Button>
  );
};

export const DataTableDesktopHeaderMenu = ({
  setSearchAnchor,
  setFilterAnchor,
  setSettingsAnchor,
  useTableContext,
  openScanner,
}: {
  setSearchAnchor: (anchor: null | HTMLElement) => void;
  setFilterAnchor: (anchor: null | HTMLElement) => void;
  setSettingsAnchor: (anchor: null | HTMLElement) => void;
  useTableContext: any;
  openScanner: () => void;
}) => {
  const { filters, searchValue } = useTableContext();

  return (
    <Box
      sx={{ width: dataTableResponsiveWidth, m: "0 auto", pt: 1, pb: 1 }}
      className="controls-bar desktop top"
    >
      <Stack
        sx={{ height: "100%" }}
        justifyContent="space-between"
        alignItems={"center"}
        direction="row"
      >
        <Stack direction="row" spacing={1}>
          <ControlsIconButton
            onClick={(e) => setSearchAnchor(e.currentTarget)}
            icon={<SearchIcon fontSize="small" />}
            count={searchValue && searchValue !== "" ? "ghost" : undefined}       
          />
          <ControlsIconButton
            count={filters.length}
            onClick={(e) => setFilterAnchor(e.currentTarget)}
            icon={<TuneIcon fontSize="small" />}
          />
          <Divider orientation="vertical" flexItem />
          <ControlsIconButton
            onClick={openScanner}
            icon={<BarcodeReaderIcon fontSize="small" />}
          />
        </Stack>

        <Box>
          <IconButton onClick={(e) => setSettingsAnchor(e.currentTarget)}>
            <SettingsIcon />
          </IconButton>
        </Box>
      </Stack>
    </Box>
  );
};
